export var SUPPORT_EMAIL = 'support@gofisherman.com';